import React from "react"
import { Row, Col, Table, Button,Badge } from "reactstrap"
import { useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
//redux
const FileRequirementDelete = props => {
  const { t } = useTranslation()
  // eslint-disable-next-line react/prop-types
  const { selectRows, handleDelete, handleClose } = props
  return (
    <>
      <h5>
        <strong>{t("global:messageDelete")}</strong>
      </h5>

      <Table striped>
        <thead>
          <tr>

            <th>{t("files:titleNameFile")}</th>
            <th>{t("files:titleAreaSupplier")}</th>
            <th>{t("materialSupplier:titleSingle")}</th>
          </tr>
        </thead>
        <tbody>
          {selectRows?.map((row, index) => (
            <tr key={index}>

              <td><div>{row.fileName}</div>
                <div className="text-muted small">{row.updateFrequency}</div>
              </td>
              <td><div>
                {row.supplier?.name}
                <h6 className="text-muted">{row.area?.name}</h6></div></td>
              <td><div className=" text-lowercase">{row?.material?.description}
                <div><Badge>{row?.material?.codeSap}</Badge></div></div></td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Row>  
        <Col>
          <div className="modal-footer">
            <Button color="danger" onClick={handleDelete}>
              {t("global:delete")}
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              {t("global:exit")}
            </Button>
          </div>
        </Col>
      </Row>
    </>
  )
}
export default withRouter(FileRequirementDelete)
